import React from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import UserAgreement from "./pages/UserAgreement";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-links">
        <Link to="/agreement">用户协议</Link>
        <span className="divider">|</span>
        <Link to="/privacy">隐私政策</Link>
      </div>

      <div className="footer-beian">
        <a
          className="beian-link"
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noreferrer"
        >
          辽ICP备2025069085号-1
        </a>
        <a
          className="beian-link beian-ga"
          href="https://beian.mps.gov.cn/#/query/webSearch?code=21021702000840"
          target="_blank"
          rel="noreferrer"
        >
          <img src="/gongan.png" alt="" className="beian-icon" />
          辽公网安备21021702000840号
        </a>
      </div>

      <p className="footer-copyright">© 2026 大连未来筑造科技有限公司</p>
    </footer>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="app">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/agreement"
            element={
              <>
                <header className="header header-sub">
                  <h1 onClick={() => (window.location.href = "/")}>来往</h1>
                </header>
                <main className="container">
                  <div className="content">
                    <UserAgreement />
                  </div>
                </main>
              </>
            }
          />
          <Route
            path="/privacy"
            element={
              <>
                <header className="header header-sub">
                  <h1 onClick={() => (window.location.href = "/")}>来往</h1>
                </header>
                <main className="container">
                  <div className="content">
                    <PrivacyPolicy />
                  </div>
                </main>
              </>
            }
          />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
